import {
	initiateTransactionDataFetchingWithJustKeyId,
	initiateTransactionDataFetchingWithProxy,
} from '../../api/consumerDataPullSessionApi'
import { ReceiverResult } from '../../types'
import { decodeBase64State } from '../stateDecoder'

export const receiveBec = async (
	queryParameters: any,
): Promise<ReceiverResult> => {
	let becConsentApproved: boolean | null = null
	let keyId: string | null = null
	if (queryParameters?.consentgiven != null) {
		becConsentApproved = queryParameters.consentgiven
		keyId = queryParameters.keyid
	}

	const decodedBase64State = decodeBase64State(queryParameters?.keyid)
	if (decodedBase64State != null) {
		try {
			const response = await initiateTransactionDataFetchingWithProxy(
				decodedBase64State.url,
				decodedBase64State.keyId,
				queryParameters.code,
			)
			return { success: true, applicantId: response.applicantId }
		} catch {
			return { success: false }
		}
	}

	if (becConsentApproved != null && keyId != null) {
		try {
			const response = await initiateTransactionDataFetchingWithJustKeyId(keyId)
			return { success: true, applicantId: response.applicantId }
		} catch {
			return { success: false }
		}
	}
	return { success: false }
}
